'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Label = require('react-bootstrap/lib/Label');

var _Label2 = _interopRequireDefault(_Label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Label2.default;